import VersionIcon from './VersionIcon'

export * from './VersionIcon'

export default VersionIcon
